const duration = 300
export const fadeIn = ($jq, queue) => {
  $jq.css('opacity', 0)
  $jq.show()
  $jq.animate({
    opacity: 1
  }, {
    duration,
    queue: queue
  }).dequeue(queue)
}
export const fadeOut = ($jq, queue) => {
  $jq.animate({
    opacity: 0
  }, {
    duration,
    queue: queue,
    complete: function () {
      $jq.hide()
    }
  }).dequeue(queue)
}
